<div class="spend__credit__popup">
  <div class="modal-header">
    <div class="modal-title">
      <span>See the final value</span>
    </div>
  </div>

  <div class="modal-body p-4 text-center">
    <div class="row">
      <div class="col-md-12">
        <div class="body__text">Spend <span class="color--blue">the credit</span></div>
        <div class="small__text">Do you really want to spend the credit to see the final value?</div>
      </div>
    </div>

    <div class="row p-3 mt-4 d-flex">
      <button type="button" class="col-md-6 button color--blue medium__button popup__button" (click)="confirm()">
        Yes
      </button>
      <button type="button" class="col-md-6 button medium__button popup__button" (click)="decline()">
        No
      </button>
    </div>
  </div>
</div>
